import { ScrollArea } from '@/components/ui/scroll-area';
import { School, AlertCircle, CheckCircle } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SchoolClosuresSection = () => {
  const [closureData, setClosureData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchClosures = async () => {
    try {
      const response = await axios.get(`${API}/schools/closures`);
      setClosureData(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching school closures:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClosures();
    // Refresh every 30 minutes
    const interval = setInterval(fetchClosures, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="content-card" data-testid="school-closures-section">
      <div className="card-header">
        <h2>
          <School size={20} className="inline" /> Norfolk School Closures
        </h2>
      </div>
      <ScrollArea className="card-content">
        {loading ? (
          <p className="loading-text">Loading school closure information...</p>
        ) : closureData ? (
          <div className="school-closures-container">
            {/* Status Summary */}
            <div className="closure-summary">
              <div className="summary-header">
                {closureData.count === 0 ? (
                  <div className="status-ok-banner">
                    <CheckCircle size={24} className="status-icon" />
                    <div>
                      <h3>All Schools Open</h3>
                      <p>No emergency closures reported</p>
                    </div>
                  </div>
                ) : (
                  <div className="status-alert-banner">
                    <AlertCircle size={24} className="status-icon" />
                    <div>
                      <h3>{closureData.count} School Closure{closureData.count > 1 ? 's' : ''}</h3>
                      <p>{closureData.date}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Closure List */}
            {closureData.closures && closureData.closures.length > 0 && (
              <div className="closures-list">
                {closureData.closures.map((closure, index) => (
                  <div key={`${closure.school_name}-${closure.status}`} className="closure-item" data-testid={`closure-${index}`}>
                    <div className="closure-header">
                      <School size={16} className="school-icon" />
                      <h4 className="school-name">{closure.school_name}</h4>
                    </div>
                    <div className="closure-details">
                      <span className="closure-status">{closure.status}</span>
                      <p className="closure-reason">{closure.reason}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Last Updated Info */}
            <div className="closure-footer">
              <p className="last-updated">
                {closureData.last_updated || 'Last checked: Just now'}
              </p>
              <a 
                href="http://disruptions.norfolk.gov.uk/nccclosures_schools.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="external-link"
              >
                View official Norfolk CC page →
              </a>
            </div>
          </div>
        ) : (
          <p className="no-data">Unable to load school closure information</p>
        )}
      </ScrollArea>
    </div>
  );
};

export default SchoolClosuresSection;
